import { render, staticRenderFns } from "./SellerAccountDetails.vue?vue&type=template&id=21b77527&scoped=true"
import script from "./SellerAccountDetails.vue?vue&type=script&lang=js"
export * from "./SellerAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./SellerAccountDetails.vue?vue&type=style&index=0&id=21b77527&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b77527",
  null
  
)

export default component.exports